// data/airlines.js

const airlines = [
  {
    name: "Helijet",
    code: "JB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JB@2x.png"
  },
  {
    name: "Douniah Airlines",
    code: "DH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DH@2x.png"
  },
  {
    name: "Luxair",
    code: "LG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LG@2x.png"
  },
  {
    name: "Akasa Air",
    code: "QP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QP@2x.png"
  },
  {
    name: "Air Serbia",
    code: "JU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JU@2x.png"
  },
  {
    name: "Jet Aviation Business",
    code: "PP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PP@2x.png"
  },
  {
    name: "Copa Airlines",
    code: "CM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CM@2x.png"
  },
  {
    name: "Linea Aerea Carguera de Colombia S.A.",
    code: "L7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L7@2x.png"
  },
  {
    name: "Deutsche Bahn AG",
    code: "2A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2A@2x.png"
  },
  {
    name: "Mercury Air Cargo, Inc.",
    code: "4X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4X@2x.png"
  },
  {
    name: "BQB Lineas Aereas",
    code: "5Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5Q@2x.png"
  },
  {
    name: "Air CÃ´te d'Ivoire",
    code: "HF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HF@2x.png"
  },
  {
    name: "Boliviana de AviaciÃ³n",
    code: "OB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OB@2x.png"
  },
  {
    name: "Hewlett-Packard (Schweiz) GmbH",
    code: "1C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1C@2x.png"
  },
  {
    name: "Alliance Air",
    code: "9I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9I@2x.png"
  },
  {
    name: "Thai Vietjet Air",
    code: "VZ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VZ@2x.png"
  },
  {
    name: "TACA Peru",
    code: "T0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T0@2x.png"
  },
  {
    name: "Conquest Air, Inc.",
    code: "C4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C4@2x.png"
  },
  {
    name: "Chengdu Airlines",
    code: "EU",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/EU@2x.png"
  },
  {
    name: "Russian Railways",
    code: "R0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R0@2x.png"
  },
  {
    name: "Turkish Airlines",
    code: "TK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TK@2x.png"
  },
  {
    name: "Polar Airlines",
    code: "PI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PI@2x.png"
  },
  {
    name: "KrasAvia",
    code: "KV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KV@2x.png"
  },
  {
    name: "TACA Airlines",
    code: "TA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TA@2x.png"
  },
  {
    name: "Chongqing Airlines",
    code: "OQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OQ@2x.png"
  },
  {
    name: "Tropic Air Limited",
    code: "9N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9N@2x.png"
  },
  {
    name: "DHL Aero Expreso S.A.",
    code: "D5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D5@2x.png"
  },
  {
    name: "Air Botswana",
    code: "BP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BP@2x.png"
  },
  {
    name: "Air Choice One",
    code: "3E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3E@2x.png"
  },
  {
    name: "Meraj Airlines",
    code: "0I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0I@2x.png"
  },
  {
    name: "Major Airline",
    code: "YY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YY@2x.png"
  },
  {
    name: "Major Airline",
    code: "XX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XX@2x.png"
  },
  {
    name: "Air East",
    code: "ER",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ER@2x.png"
  },
  {
    name: "Asian Express Airline",
    code: "00",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/00@2x.png"
  },
  {
    name: "9G Rail",
    code: "9G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9G@2x.png"
  },
  {
    name: "Air Ocean",
    code: "0O",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0O@2x.png"
  },
  {
    name: "Yan Air Ltd",
    code: "YE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YE@2x.png"
  },
  {
    name: "Norwegian Long Haul",
    code: "DU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DU@2x.png"
  },
  {
    name: "Air Creebec",
    code: "YN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YN@2x.png"
  },
  {
    name: "Swoop",
    code: "WO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WO@2x.png"
  },
  {
    name: "Santa Barbara Airlines",
    code: "S3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S3@2x.png"
  },
  {
    name: "Aklak Air",
    code: "6L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6L@2x.png"
  },
  {
    name: "Cobham Aviation Services Australia",
    code: "NC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NC@2x.png"
  },
  {
    name: "Cityjet",
    code: "WX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WX@2x.png"
  },
  {
    name: "AsercaÂ Airlines",
    code: "R7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R7@2x.png"
  },
  {
    name: "Vision Airlines",
    code: "V2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V2@2x.png"
  },
  {
    name: "Sundair",
    code: "SR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SR@2x.png"
  },
  {
    name: "Tigerair Mandala",
    code: "RI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RI@2x.png"
  },
  {
    name: "Lufthansa Systems",
    code: "S1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S1@2x.png"
  },
  {
    name: "Guangxi Beibu Gulf Airlines Co., Ltd.",
    code: "GP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GP@2x.png"
  },
  {
    name: "Westjet",
    code: "WS",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/WS@2x.png"
  },
  {
    name: "Atlasjet Ukraine",
    code: "UH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UH@2x.png"
  },
  {
    name: "Orbest",
    code: "6O",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6O@2x.png"
  },
  {
    name: "Seaborne Airlines",
    code: "BB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BB@2x.png"
  },
  {
    name: "Australian Airlines",
    code: "AO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AO@2x.png"
  },
  {
    name: "Iran Air",
    code: "IR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IR@2x.png"
  },
  {
    name: "Bering Air",
    code: "8E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8E@2x.png"
  },
  {
    name: "Villa Air Pvt. Ltd. dba Villa Air",
    code: "VP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VP@2x.png"
  },
  {
    name: "Buta Airways",
    code: "55",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/55@2x.png"
  },
  {
    name: "Scoot",
    code: "TR",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TR@2x.png"
  },
  {
    name: "Angara Airlines",
    code: "2G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2G@2x.png"
  },
  {
    name: "Aerotranscargo",
    code: "F5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F5@2x.png"
  },
  {
    name: "Turkmenistan Airlines",
    code: "T5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T5@2x.png"
  },
  {
    name: "Sichuan Airlines",
    code: "3U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3U@2x.png"
  },
  {
    name: "FlyBosnia",
    code: "6W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6W@2x.png"
  },
  {
    name: "Sudan Airways",
    code: "SD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SD@2x.png"
  },
  {
    name: "Far Eastern Air Transport",
    code: "FE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FE@2x.png"
  },
  {
    name: "OAG",
    code: "CR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CR@2x.png"
  },
  {
    name: "FlyDamas",
    code: "4J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4J@2x.png"
  },
  {
    name: "Air City",
    code: "4F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4F@2x.png"
  },
  {
    name: "Regional Express",
    code: "ZL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZL@2x.png"
  },
  {
    name: "Czech Airlines",
    code: "OK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OK@2x.png"
  },
  {
    name: "Yemenia",
    code: "IY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IY@2x.png"
  },
  {
    name: "Air Caledonie",
    code: "TY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TY@2x.png"
  },
  {
    name: "As Avies",
    code: "U3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U3@2x.png"
  },
  {
    name: "Siam Ga Co. Ltd.",
    code: "5E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5E@2x.png"
  },
  {
    name: "Hi Air",
    code: "4H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4H@2x.png"
  },
  {
    name: "China West Air",
    code: "PN",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/PN@2x.png"
  },
  {
    name: "Chang An Airlines",
    code: "9H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9H@2x.png"
  },
  {
    name: "Travel Air",
    code: "4P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4P@2x.png"
  },
  {
    name: "Maldivian",
    code: "Q2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q2@2x.png"
  },
  {
    name: "Air Greenland",
    code: "GL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GL@2x.png"
  },
  {
    name: "All Nippon Airways",
    code: "NH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NH@2x.png"
  },
  {
    name: "Delta Connection",
    code: "DQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DQ@2x.png"
  },
  {
    name: "Hawaiian Airlines",
    code: "HA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HA@2x.png"
  },
  {
    name: "Avion Express",
    code: "X9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X9@2x.png"
  },
  {
    name: "Afrinat International Airlines",
    code: "2F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2F@2x.png"
  },
  {
    name: "Fuzhou Airlines",
    code: "FU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FU@2x.png"
  },
  {
    name: "Gambia Bird Airlines",
    code: "3G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3G@2x.png"
  },
  {
    name: "Wamos Air",
    code: "EB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EB@2x.png"
  },
  {
    name: "Air China",
    code: "CA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CA@2x.png"
  },
  {
    name: "South African Airways",
    code: "SA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SA@2x.png"
  },
  {
    name: "Panorama Airways",
    code: "5P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5P@2x.png"
  },
  {
    name: "PT Aerosystems Indonesia",
    code: "1T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1T@2x.png"
  },
  {
    name: "Asiana Airlines",
    code: "OZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OZ@2x.png"
  },
  {
    name: "Wizz Air",
    code: "W6",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/W6@2x.png"
  },
  {
    name: "Air Sunshine Inc.",
    code: "YI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YI@2x.png"
  },
  {
    name: "White Airways",
    code: "WI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WI@2x.png"
  },
  {
    name: "Afric Aviation",
    code: "L8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L8@2x.png"
  },
  {
    name: "Urumqi Air",
    code: "UQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UQ@2x.png"
  },
  {
    name: "FlyCorporate",
    code: "FC",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FC@2x.png"
  },
  {
    name: "Hellas Jet",
    code: "HJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HJ@2x.png"
  },
  {
    name: "Air Dilijans",
    code: "RM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RM@2x.png"
  },
  {
    name: "Skyward Express",
    code: "OW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OW@2x.png"
  },
  {
    name: "Air Liaison",
    code: "Q9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q9@2x.png"
  },
  {
    name: "Indonesia AirAsia",
    code: "QZ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/QZ@2x.png"
  },
  {
    name: "Air Iceland",
    code: "NY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NY@2x.png"
  },
  {
    name: "Air Italy",
    code: "IG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/IG@2x.png"
  },
  {
    name: "Sounds Air Travel & Tourism Ltd.",
    code: "S8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S8@2x.png"
  },
  {
    name: "Georgian Wings",
    code: "D4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D4@2x.png"
  },
  {
    name: "Avior Airlines",
    code: "9V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9V@2x.png"
  },
  {
    name: "SATA",
    code: "S4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S4@2x.png"
  },
  {
    name: "Nok Air",
    code: "DD",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DD@2x.png"
  },
  {
    name: "People's Viennaline",
    code: "PE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PE@2x.png"
  },
  {
    name: "Airnorth",
    code: "TL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TL@2x.png"
  },
  {
    name: "VIM Airlines",
    code: "NN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NN@2x.png"
  },
  {
    name: "Kenn Borek Air Ltd.",
    code: "4K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4K@2x.png"
  },
  {
    name: "Animawings",
    code: "A2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A2@2x.png"
  },
  {
    name: "Air Arabia Abu Dhabi",
    code: "3L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3L@2x.png"
  },
  {
    name: "Palau National Airlines",
    code: "4L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4L@2x.png"
  },
  {
    name: "Thai Smile",
    code: "WE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WE@2x.png"
  },
  {
    name: "VIA Rail Canada Inc.",
    code: "2R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2R@2x.png"
  },
  {
    name: "T'way Air",
    code: "TW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TW@2x.png"
  },
  {
    name: "UM Airlines",
    code: "UF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UF@2x.png"
  },
  {
    name: "Gol Transportes AÃ©reos",
    code: "G3",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/G3@2x.png"
  },
  {
    name: "Welcome Air",
    code: "2W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2W@2x.png"
  },
  {
    name: "Sharp Airlines",
    code: "SH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SH@2x.png"
  },
  {
    name: "Electronic Data Systems Corporation",
    code: "1Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1Y@2x.png"
  },
  {
    name: "B&H Airlines",
    code: "JA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JA@2x.png"
  },
  {
    name: "Lumiwings",
    code: "L9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L9@2x.png"
  },
  {
    name: "Blue Air",
    code: "0B",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/0B@2x.png"
  },
  {
    name: "InterCaribbean Airways",
    code: "JY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JY@2x.png"
  },
  {
    name: "Syphax Airlines",
    code: "FS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FS@2x.png"
  },
  {
    name: "Northwest Airlines",
    code: "NW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NW@2x.png"
  },
  {
    name: "Norse Atlantic UK",
    code: "Z0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z0@2x.png"
  },
  {
    name: "Air Namibia",
    code: "SW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SW@2x.png"
  },
  {
    name: "Air Caraibes",
    code: "TX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TX@2x.png"
  },
  {
    name: "Manx2",
    code: "NM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NM@2x.png"
  },
  {
    name: "SeaPort Airlines",
    code: "K5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K5@2x.png"
  },
  {
    name: "Alpha Air Transport",
    code: "7U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7U@2x.png"
  },
  {
    name: "Volga-Dnepr Airlines",
    code: "VI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VI@2x.png"
  },
  {
    name: "Insel Air",
    code: "7I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7I@2x.png"
  },
  {
    name: "Ibex Airlines",
    code: "FW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FW@2x.png"
  },
  {
    name: "Travel Service Polska Sp. z.o.o.",
    code: "3Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3Z@2x.png"
  },
  {
    name: "Bhutan Airlines",
    code: "B3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B3@2x.png"
  },
  {
    name: "China Southern Airlines",
    code: "CZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CZ@2x.png"
  },
  {
    name: "PT Republic Express Airlines",
    code: "RH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RH@2x.png"
  },
  {
    name: "US Airways",
    code: "US",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/US@2x.png"
  },
  {
    name: "Tatarstan Airlines",
    code: "U9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U9@2x.png"
  },
  {
    name: "Oman Air",
    code: "WY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WY@2x.png"
  },
  {
    name: "A.P.G. Distribution System",
    code: "A1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A1@2x.png"
  },
  {
    name: "MHS Aviation",
    code: "M2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M2@2x.png"
  },
  {
    name: "Silk Way Airlines",
    code: "ZP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZP@2x.png"
  },
  {
    name: "Lynx Air",
    code: "Y9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Y9@2x.png"
  },
  {
    name: "National Airlines",
    code: "N8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N8@2x.png"
  },
  {
    name: "Air Excel",
    code: "0X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0X@2x.png"
  },
  {
    name: "Premium Jet AG",
    code: "0J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0J@2x.png"
  },
  {
    name: "Nauru Airline",
    code: "ON",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ON@2x.png"
  },
  {
    name: "Air Cargo Carriers, LLC.",
    code: "2Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2Q@2x.png"
  },
  {
    name: "La Compagnie",
    code: "B0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B0@2x.png"
  },
  {
    name: "LATAM Brasil",
    code: "JJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JJ@2x.png"
  },
  {
    name: "Coastal Travels",
    code: "CQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CQ@2x.png"
  },
  {
    name: "Air Antilles Express",
    code: "3S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3S@2x.png"
  },
  {
    name: "Jet Ops",
    code: "J6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J6@2x.png"
  },
  {
    name: "Croatia Airlines",
    code: "OU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OU@2x.png"
  },
  {
    name: "Flyadeal",
    code: "F3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F3@2x.png"
  },
  {
    name: "Winair",
    code: "WM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WM@2x.png"
  },
  {
    name: "LASER Airlines",
    code: "QL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QL@2x.png"
  },
  {
    name: "Alaska Airlines",
    code: "AS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AS@2x.png"
  },
  {
    name: "Amaszonas",
    code: "Z7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z7@2x.png"
  },
  {
    name: "Air India",
    code: "AI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AI@2x.png"
  },
  {
    name: 'JSC "Sirena-Travel"',
    code: "1H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1H@2x.png"
  },
  {
    name: "Cebu Pacific",
    code: "5J",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/5J@2x.png"
  },
  {
    name: "PLAY",
    code: "OG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OG@2x.png"
  },
  {
    name: "Polynesian Airlines",
    code: "OL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OL@2x.png"
  },
  {
    name: "Syrian Arab Airlines",
    code: "RB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RB@2x.png"
  },
  {
    name: "Vueling",
    code: "VY",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VY@2x.png"
  },
  {
    name: "Qatar Airways",
    code: "QR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QR@2x.png"
  },
  {
    name: "Aerorepublica",
    code: "P5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P5@2x.png"
  },
  {
    name: "Wings of Lebanon S.a.l",
    code: "W7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W7@2x.png"
  },
  {
    name: "Andes Lineas Aereas",
    code: "OY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OY@2x.png"
  },
  {
    name: "SunExpress Deutschland",
    code: "XG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XG@2x.png"
  },
  {
    name: "Korean Air",
    code: "KE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KE@2x.png"
  },
  {
    name: "Merpati Nusantara Airlines",
    code: "MZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MZ@2x.png"
  },
  {
    name: "Southwest Airlines",
    code: "WN",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/WN@2x.png"
  },
  {
    name: "Riyadh Air",
    code: "RX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RX@2x.png"
  },
  {
    name: "SCAT",
    code: "DV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DV@2x.png"
  },
  {
    name: "Fly Jamaica Airways",
    code: "OJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OJ@2x.png"
  },
  {
    name: "Trans States Airlines",
    code: "AX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AX@2x.png"
  },
  {
    name: "Blue Bird Airways",
    code: "BZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BZ@2x.png"
  },
  {
    name: "Air Tindi",
    code: "8T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8T@2x.png"
  },
  {
    name: "LATAM Paraguay",
    code: "PZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PZ@2x.png"
  },
  {
    name: "Shandong Airlines",
    code: "SC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SC@2x.png"
  },
  {
    name: "Sky Wings Airlines",
    code: "ND",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ND@2x.png"
  },
  {
    name: "Libyan Airlines",
    code: "LN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LN@2x.png"
  },
  {
    name: "Jet Airways Inc.",
    code: "QJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QJ@2x.png"
  },
  {
    name: "Oriental Air Bridge",
    code: "OC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OC@2x.png"
  },
  {
    name: "Jet Lite",
    code: "S2",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/S2@2x.png"
  },
  {
    name: "Jiangxi Air",
    code: "RY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RY@2x.png"
  },
  {
    name: "Halcyonair",
    code: "7Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7Z@2x.png"
  },
  {
    name: "Fly540",
    code: "5H",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/5H@2x.png"
  },
  {
    name: "Cape Air",
    code: "9K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9K@2x.png"
  },
  {
    name: "Germania Flug",
    code: "GM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GM@2x.png"
  },
  {
    name: "Fly CamInter",
    code: "EF",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/EF@2x.png"
  },
  {
    name: "AirAsia",
    code: "AK",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/AK@2x.png"
  },
  {
    name: "Hesa Airlines",
    code: "H8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/H8@2x.png"
  },
  {
    name: "Qingdao Airlines",
    code: "QW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QW@2x.png"
  },
  {
    name: "Proflight Zambia",
    code: "P0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P0@2x.png"
  },
  {
    name: "Small Planet Airlines",
    code: "P7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P7@2x.png"
  },
  {
    name: "Amtrak",
    code: "2V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2V@2x.png"
  },
  {
    name: "Eastern Airlines, LLC",
    code: "2D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2D@2x.png"
  },
  {
    name: "Travel Service",
    code: "7O",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7O@2x.png"
  },
  {
    name: "Air Madagascar",
    code: "MD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MD@2x.png"
  },
  {
    name: "Air Canada",
    code: "AC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AC@2x.png"
  },
  {
    name: "VLM Airlines",
    code: "VG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VG@2x.png"
  },
  {
    name: "BRA",
    code: "TF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TF@2x.png"
  },
  {
    name: "Air Austral",
    code: "UU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UU@2x.png"
  },
  {
    name: "Bulgaria Air",
    code: "FB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FB@2x.png"
  },
  {
    name: "Ruili Airlines",
    code: "DR",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DR@2x.png"
  },
  {
    name: "UPS",
    code: "5X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5X@2x.png"
  },
  {
    name: "HÃ©li SÃ©curitÃ© HÃ©licopter Airline",
    code: "HS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HS@2x.png"
  },
  {
    name: "Alliance Airlines",
    code: "QQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QQ@2x.png"
  },
  {
    name: "Emirates",
    code: "EK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EK@2x.png"
  },
  {
    name: "Grant Aviation, Inc.",
    code: "GV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GV@2x.png"
  },
  {
    name: "Provincial Airlines",
    code: "PB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PB@2x.png"
  },
  {
    name: "ZanAir",
    code: "B4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B4@2x.png"
  },
  {
    name: "SITA - Airlines WorldwideTelecommunications and Information Svcs",
    code: "XS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XS@2x.png"
  },
  {
    name: "Uzbekistan Airways",
    code: "HY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HY@2x.png"
  },
  {
    name: "Blue Panorama Airlines",
    code: "BV",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/BV@2x.png"
  },
  {
    name: "Ningxia Cargo Airlines CO.,LTD",
    code: "HT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HT@2x.png"
  },
  {
    name: "airblue",
    code: "PA",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/PA@2x.png"
  },
  {
    name: "Jonika Airlines",
    code: "JO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JO@2x.png"
  },
  {
    name: "Okay Airways",
    code: "BK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BK@2x.png"
  },
  {
    name: "Quikjet Cargo Airlines Pvt. Ltd",
    code: "QO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QO@2x.png"
  },
  {
    name: "Wizz Air Ukraine",
    code: "WU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WU@2x.png"
  },
  {
    name: "Cobalt Air",
    code: "CO",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/CO@2x.png"
  },
  {
    name: "Air Mauritius",
    code: "MK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MK@2x.png"
  },
  {
    name: "Iran Aseman Airlines",
    code: "EP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EP@2x.png"
  },
  {
    name: "Endeavor Air",
    code: "9E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9E@2x.png"
  },
  {
    name: "Eva Air",
    code: "BR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BR@2x.png"
  },
  {
    name: "Spring Airlines Japan",
    code: "IJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/IJ@2x.png"
  },
  {
    name: "Regional Air Services",
    code: "8N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8N@2x.png"
  },
  {
    name: "Peruvian Airlines",
    code: "P9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P9@2x.png"
  },
  {
    name: "easyJet Switzerland",
    code: "DS",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DS@2x.png"
  },
  {
    name: "Afrosiyob",
    code: "0U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0U@2x.png"
  },
  {
    name: "Air Excursion, LLC",
    code: "X4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X4@2x.png"
  },
  {
    name: "Cambodia Angkor Air",
    code: "K6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K6@2x.png"
  },
  {
    name: "Jetstar",
    code: "JQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JQ@2x.png"
  },
  {
    name: "BVI Airways",
    code: "XV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XV@2x.png"
  },
  {
    name: "AIS Airlines B.V.",
    code: "IS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IS@2x.png"
  },
  {
    name: "Blue1",
    code: "KF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KF@2x.png"
  },
  {
    name: "Jambojet",
    code: "JM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JM@2x.png"
  },
  {
    name: "Aviacon Zitotrans Air Company JSC",
    code: "ZR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZR@2x.png"
  },
  {
    name: "SkyWork Airlines",
    code: "SX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SX@2x.png"
  },
  {
    name: "China Postal Airlines Ltd.",
    code: "CF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CF@2x.png"
  },
  {
    name: "Azerbaijan Airlines",
    code: "J2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J2@2x.png"
  },
  {
    name: "Globus Airlines",
    code: "GH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GH@2x.png"
  },
  {
    name: "Air Incheon",
    code: "KJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KJ@2x.png"
  },
  {
    name: "Hahn Air",
    code: "HR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HR@2x.png"
  },
  {
    name: "Jet Express",
    code: "G2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/G2@2x.png"
  },
  {
    name: "Super Air Jet",
    code: "IU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IU@2x.png"
  },
  {
    name: "Jet Airways",
    code: "9W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9W@2x.png"
  },
  {
    name: "Lignes Aeriennes Congolaises",
    code: "4V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4V@2x.png"
  },
  {
    name: "Red Sea Airlines",
    code: "4S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4S@2x.png"
  },
  {
    name: "Lynx Aviation",
    code: "L3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L3@2x.png"
  },
  {
    name: "Amerijet International Inc.",
    code: "M6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M6@2x.png"
  },
  {
    name: "Jazeera Airways",
    code: "J9",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/J9@2x.png"
  },
  {
    name: "Air Saint Pierre",
    code: "PJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PJ@2x.png"
  },
  {
    name: "Pakistan International Airlines",
    code: "PK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PK@2x.png"
  },
  {
    name: "Tajik Air",
    code: "7J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7J@2x.png"
  },
  {
    name: "Fuji Dream Airlines",
    code: "JH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JH@2x.png"
  },
  {
    name: "Trade Air",
    code: "C3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C3@2x.png"
  },
  {
    name: "Kostroma Air",
    code: "ÐšÐ‘",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ÐšÐ‘@2x.png"
  },
  {
    name: "Raya Airways Sdn. Bhd.dba Raya Airways",
    code: "TH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TH@2x.png"
  },
  {
    name: "AerolÃ­neas Sosa",
    code: "P4",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/P4@2x.png"
  },
  {
    name: "Webjet Linhas Aereas",
    code: "WH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WH@2x.png"
  },
  {
    name: "Sun Air Express",
    code: "6G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6G@2x.png"
  },
  {
    name: "Buraq Air Transport (BRQ)",
    code: "UZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UZ@2x.png"
  },
  {
    name: "Belavia",
    code: "B2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B2@2x.png"
  },
  {
    name: "Aero Contractors",
    code: "NG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NG@2x.png"
  },
  {
    name: "Rossiya Airlines",
    code: "FV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FV@2x.png"
  },
  {
    name: "Virgin America ",
    code: "VX",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VX@2x.png"
  },
  {
    name: "New England Airlines",
    code: "EJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EJ@2x.png"
  },
  {
    name: "Eagle Atlantic Airlines",
    code: "E2",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/E2@2x.png"
  },
  {
    name: "Euro-Asia Air",
    code: "6Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6Z@2x.png"
  },
  {
    name: "Trans-Mediterranean Airways",
    code: "N2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N2@2x.png"
  },
  {
    name: "Ellinair",
    code: "EL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EL@2x.png"
  },
  {
    name: "SpiceJet",
    code: "SG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/SG@2x.png"
  },
  {
    name: "St Barth Commuter",
    code: "PV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PV@2x.png"
  },
  {
    name: "Atlas Global Airlines",
    code: "KK",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/KK@2x.png"
  },
  {
    name: "Nova Airways",
    code: "N9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N9@2x.png"
  },
  {
    name: "North-Wright Airways",
    code: "HW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HW@2x.png"
  },
  {
    name: "Porter Airlines",
    code: "PD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PD@2x.png"
  },
  {
    name: "BMI Regional",
    code: "BM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BM@2x.png"
  },
  {
    name: "China Eastern Airlines",
    code: "MU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MU@2x.png"
  },
  {
    name: "Kuwait Airways",
    code: "KU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KU@2x.png"
  },
  {
    name: "JETGO Australia",
    code: "JG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JG@2x.png"
  },
  {
    name: "Binter Canarias",
    code: "NT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NT@2x.png"
  },
  {
    name: "Avianca Brazil",
    code: "O6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O6@2x.png"
  },
  {
    name: "Amadeus IT Group SA",
    code: "1A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1A@2x.png"
  },
  {
    name: "Bees Airline",
    code: "7B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7B@2x.png"
  },
  {
    name: "Stabo Air Limited",
    code: "4E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4E@2x.png"
  },
  {
    name: "Northwestern Air",
    code: "J3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J3@2x.png"
  },
  {
    name: "Brit Air",
    code: "DB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DB@2x.png"
  },
  {
    name: "Jetstar Pacific Airlines",
    code: "BL",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/BL@2x.png"
  },
  {
    name: "Tayaran Jet",
    code: "E8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/E8@2x.png"
  },
  {
    name: "Air Arabia Jordan",
    code: "9P",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/9P@2x.png"
  },
  {
    name: "Jetstar Asia",
    code: "3K",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/3K@2x.png"
  },
  {
    name: "Vologda Air",
    code: "Ð’Ð“",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð’Ð“@2x.png"
  },
  {
    name: "Avia Traffic Company",
    code: "Ð¢Ð¤",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð¢Ð¤@2x.png"
  },
  {
    name: "Chalair Aviation",
    code: "CE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CE@2x.png"
  },
  {
    name: "Pegasus Airlines",
    code: "PC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PC@2x.png"
  },
  {
    name: "Aigle Azur",
    code: "ZI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZI@2x.png"
  },
  {
    name: "airBaltic",
    code: "BT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BT@2x.png"
  },
  {
    name: "NAM Air",
    code: "IN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IN@2x.png"
  },
  {
    name: "Aero Transporte S.A.",
    code: "4A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4A@2x.png"
  },
  {
    name: "Air Sinai",
    code: "4D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4D@2x.png"
  },
  {
    name: "Globus LLÐ¡",
    code: "XT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XT@2x.png"
  },
  {
    name: "Public Charters",
    code: "P1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P1@2x.png"
  },
  {
    name: "HiSky",
    code: "H7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/H7@2x.png"
  },
  {
    name: "Air Tahiti",
    code: "VT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VT@2x.png"
  },
  {
    name: "Connellan air disaster",
    code: "RF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RF@2x.png"
  },
  {
    name: "NokScoot",
    code: "XW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XW@2x.png"
  },
  {
    name: "8165343 Canada Inc. dba Air Canada rouge",
    code: "RV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RV@2x.png"
  },
  {
    name: "Hahn Air",
    code: "H1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/H1@2x.png"
  },
  {
    name: "Cronos Airlines",
    code: "C8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C8@2x.png"
  },
  {
    name: "Loong Air",
    code: "GJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GJ@2x.png"
  },
  {
    name: "Private Wings",
    code: "8W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8W@2x.png"
  },
  {
    name: "fly2sky",
    code: "F6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F6@2x.png"
  },
  {
    name: "Aeromar",
    code: "VW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VW@2x.png"
  },
  {
    name: "Air Vanuatu",
    code: "NF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NF@2x.png"
  },
  {
    name: "KLM Cityhopper",
    code: "WA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WA@2x.png"
  },
  {
    name: "Eastern Airways",
    code: "T3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T3@2x.png"
  },
  {
    name: "LAN Chile Cargo",
    code: "UC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UC@2x.png"
  },
  {
    name: "Nesma Airlines",
    code: "NA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NA@2x.png"
  },
  {
    name: "Air Mandalay",
    code: "6T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6T@2x.png"
  },
  {
    name: "40-Mile Air",
    code: "Q5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q5@2x.png"
  },
  {
    name: "Eurostar",
    code: "9F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9F@2x.png"
  },
  {
    name: "Camair-Co",
    code: "QC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QC@2x.png"
  },
  {
    name: "Aurora",
    code: "HZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HZ@2x.png"
  },
  {
    name: "Federal Air",
    code: "7V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7V@2x.png"
  },
  {
    name: "Air Transport Association of Americad\\b\\a Airlines for America",
    code: "XD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XD@2x.png"
  },
  {
    name: "VivaAerobus",
    code: "VB",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VB@2x.png"
  },
  {
    name: "Air Indus",
    code: "I6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I6@2x.png"
  },
  {
    name: "American Eagle",
    code: "ZZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZZ@2x.png"
  },
  {
    name: "Air Montenegro",
    code: "YM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YM@2x.png"
  },
  {
    name: "Joy Air",
    code: "JR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JR@2x.png"
  },
  {
    name: "Lion Air",
    code: "JT",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/JT@2x.png"
  },
  {
    name: "Safarilink Aviation",
    code: "F2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F2@2x.png"
  },
  {
    name: "World Ticket Ltd",
    code: "W1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W1@2x.png"
  },
  {
    name: "Aeromexico",
    code: "AM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AM@2x.png"
  },
  {
    name: "Jin Air",
    code: "LJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/LJ@2x.png"
  },
  {
    name: "Ernest Airline",
    code: "EG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EG@2x.png"
  },
  {
    name: "Viva Air Colombia",
    code: "VH",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VH@2x.png"
  },
  {
    name: "Israir Airlines",
    code: "6H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6H@2x.png"
  },
  {
    name: "Aircalin",
    code: "SB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SB@2x.png"
  },
  {
    name: "Air Service Liege",
    code: "L4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L4@2x.png"
  },
  {
    name: "Japan Airlines",
    code: "JL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JL@2x.png"
  },
  {
    name: "TIK Systems",
    code: "T1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T1@2x.png"
  },
  {
    name: "Icelandair",
    code: "FI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FI@2x.png"
  },
  {
    name: "Izhavia",
    code: "I8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I8@2x.png"
  },
  {
    name: "K-Mile Air Co. Ltd",
    code: "8K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8K@2x.png"
  },
  {
    name: "SiAvia",
    code: "KT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KT@2x.png"
  },
  {
    name: "Cargolux",
    code: "CV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CV@2x.png"
  },
  {
    name: "VietjetAir",
    code: "VJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VJ@2x.png"
  },
  {
    name: "Azimut",
    code: "A4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A4@2x.png"
  },
  {
    name: "Pascan Aviation",
    code: "P6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P6@2x.png"
  },
  {
    name: "Airmax S.A.",
    code: "X8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X8@2x.png"
  },
  {
    name: "Air Arabia Maroc",
    code: "3O",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/3O@2x.png"
  },
  {
    name: "JetSMART",
    code: "WJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WJ@2x.png"
  },
  {
    name: "Discovery Airways",
    code: "DO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DO@2x.png"
  },
  {
    name: "Bird Information Systems Private Limited",
    code: "1R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1R@2x.png"
  },
  {
    name: "Comair",
    code: "MN",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/MN@2x.png"
  },
  {
    name: "Corendon Dutch Airlines",
    code: "CD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CD@2x.png"
  },
  {
    name: "C.A.I. First",
    code: "XM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XM@2x.png"
  },
  {
    name: "JetBlue Airways",
    code: "B6",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/B6@2x.png"
  },
  {
    name: "Atlas Air",
    code: "5Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5Y@2x.png"
  },
  {
    name: "Azul Brazilian Airlines",
    code: "AD",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/AD@2x.png"
  },
  {
    name: "Travel Technology Interactive SA",
    code: "Y1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Y1@2x.png"
  },
  {
    name: "Redemption Inc.",
    code: "2O",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2O@2x.png"
  },
  {
    name: "EasyJet",
    code: "U2",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/U2@2x.png"
  },
  {
    name: "Aer Lingus",
    code: "EI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EI@2x.png"
  },
  {
    name: "LAN COLOMBIA AIRLINES",
    code: "4C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4C@2x.png"
  },
  {
    name: "Air Mekong",
    code: "P8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P8@2x.png"
  },
  {
    name: "Flair Airlines Ltd.",
    code: "F8",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/F8@2x.png"
  },
  {
    name: "NOVA Airlines",
    code: "O9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O9@2x.png"
  },
  {
    name: "Republic Airlines",
    code: "YX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YX@2x.png"
  },
  {
    name: "HelicÃ³pteros del Sureste",
    code: "UV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UV@2x.png"
  },
  {
    name: "Air Georgian Ltd. dba Air Alliance",
    code: "ZX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZX@2x.png"
  },
  {
    name: "Spring Airlines",
    code: "9C",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/9C@2x.png"
  },
  {
    name: "V Air Corporation",
    code: "ZV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZV@2x.png"
  },
  {
    name: "Air Moldova",
    code: "9U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9U@2x.png"
  },
  {
    name: "TAME Linea Aerea del Ecuador",
    code: "EQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EQ@2x.png"
  },
  {
    name: "IrAero",
    code: "IO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IO@2x.png"
  },
  {
    name: "Aero-Charter Ukraine",
    code: "DW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DW@2x.png"
  },
  {
    name: "Air Malta",
    code: "KM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KM@2x.png"
  },
  {
    name: "Tectimes Sudamerica",
    code: "C1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C1@2x.png"
  },
  {
    name: "DHL Air Limited",
    code: "D0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D0@2x.png"
  },
  {
    name: "Everts Air Cargo",
    code: "5V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5V@2x.png"
  },
  {
    name: "Eaglexpress Air Charter Sdn.Bhd.dbaEaglexpress Air",
    code: "9A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9A@2x.png"
  },
  {
    name: "Yangtze River Express",
    code: "Y8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Y8@2x.png"
  },
  {
    name: "Asia Atlantic Airlines",
    code: "HB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HB@2x.png"
  },
  {
    name: "Charter Air Transport, Inc.",
    code: "VC",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VC@2x.png"
  },
  {
    name: "West Link Airlines",
    code: "9L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9L@2x.png"
  },
  {
    name: "Mahan Airlines",
    code: "W5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W5@2x.png"
  },
  {
    name: "Pan American World Airways",
    code: "7N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7N@2x.png"
  },
  {
    name: "Air Do",
    code: "HD",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/HD@2x.png"
  },
  {
    name: "HOP!",
    code: "A5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A5@2x.png"
  },
  {
    name: "TransNusa",
    code: "8B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8B@2x.png"
  },
  {
    name: "Jet2.com",
    code: "LS",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/LS@2x.png"
  },
  {
    name: "Thalys International",
    code: "2H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2H@2x.png"
  },
  {
    name: "JetHunter",
    code: "01",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/01@2x.png"
  },
  {
    name: "Dana Airlines Limited",
    code: "9J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9J@2x.png"
  },
  {
    name: "Nature Air",
    code: "5C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5C@2x.png"
  },
  {
    name: "FITS Aviation (Pvt) Ltd",
    code: "8D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8D@2x.png"
  },
  {
    name: "ExpressJet",
    code: "XE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XE@2x.png"
  },
  {
    name: "Aerolitoral S.A. de C.V.",
    code: "5D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5D@2x.png"
  },
  {
    name: "Tarom",
    code: "RO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RO@2x.png"
  },
  {
    name: "Mistral Air",
    code: "M4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M4@2x.png"
  },
  {
    name: "Jordan Aviation",
    code: "R5",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/R5@2x.png"
  },
  {
    name: "Airlink",
    code: "4Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4Z@2x.png"
  },
  {
    name: "SalamAir",
    code: "OV",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/OV@2x.png"
  },
  {
    name: "Norwegian Air",
    code: "DN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DN@2x.png"
  },
  {
    name: "Videcom International Limited",
    code: "U1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U1@2x.png"
  },
  {
    name: "Xiamen Airlines",
    code: "MF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MF@2x.png"
  },
  {
    name: "IndiGo",
    code: "6E",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/6E@2x.png"
  },
  {
    name: "Air Macau",
    code: "NX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NX@2x.png"
  },
  {
    name: "Martinair",
    code: "MP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MP@2x.png"
  },
  {
    name: "Qeshm Air",
    code: "QB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QB@2x.png"
  },
  {
    name: "Mid Africa Aviation",
    code: "8G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8G@2x.png"
  },
  {
    name: "Ryanair",
    code: "FR",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FR@2x.png"
  },
  {
    name: "Air Mobility Command",
    code: "MC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MC@2x.png"
  },
  {
    name: "Safair",
    code: "FA",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FA@2x.png"
  },
  {
    name: "SkyJet",
    code: "M8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M8@2x.png"
  },
  {
    name: "Armenia Airways",
    code: "Ð•ÐŸ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð•ÐŸ@2x.png"
  },
  {
    name: "Transavia",
    code: "TO",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TO@2x.png"
  },
  {
    name: "Donavia",
    code: "D9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D9@2x.png"
  },
  {
    name: "Avianca Cargo",
    code: "QT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QT@2x.png"
  },
  {
    name: "S.C. Ten Airways S.R.L.",
    code: "X5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X5@2x.png"
  },
  {
    name: "Air Corsica",
    code: "XK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XK@2x.png"
  },
  {
    name: "Motor Sich Airlines",
    code: "M9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M9@2x.png"
  },
  {
    name: "AirExplore",
    code: "ED",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ED@2x.png"
  },
  {
    name: "Juneyao Airlines",
    code: "HO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HO@2x.png"
  },
  {
    name: "Gazpromavia",
    code: "4G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4G@2x.png"
  },
  {
    name: "Tus Airways",
    code: "U8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U8@2x.png"
  },
  {
    name: "Sunsplash Aviation, LLC.",
    code: "YH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YH@2x.png"
  },
  {
    name: "Aeroflot",
    code: "SU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SU@2x.png"
  },
  {
    name: "Shaheen Air",
    code: "NL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NL@2x.png"
  },
  {
    name: "Sqiva Sistem",
    code: "Q1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q1@2x.png"
  },
  {
    name: "French Blue",
    code: "BF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BF@2x.png"
  },
  {
    name: "Pegas Fly",
    code: "EO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EO@2x.png"
  },
  {
    name: "Scandinavian Airlines",
    code: "SK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SK@2x.png"
  },
  {
    name: "Tibet Airlines",
    code: "TV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TV@2x.png"
  },
  {
    name: "Chautauqua Airlines",
    code: "RP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RP@2x.png"
  },
  {
    name: "Farelogix Qatar Airways",
    code: "F1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F1@2x.png"
  },
  {
    name: "Japan Transocean Air",
    code: "NU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NU@2x.png"
  },
  {
    name: "CommutAir",
    code: "C5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C5@2x.png"
  },
  {
    name: "Fly Jordan",
    code: "F0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F0@2x.png"
  },
  {
    name: "PT Kal Star Aviation",
    code: "KD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KD@2x.png"
  },
  {
    name: "Frontier Airlines",
    code: "F9",
    is_lowcost: true,
    logo: "https://door2door-assets.s3.amazonaws.com/airline-logo/FF.png"
  },
  {
    name: "Ravn Alaska",
    code: "7H",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/7H@2x.png"
  },
  {
    name: "UIA",
    code: "PS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PS@2x.png"
  },
  {
    name: "Golden Myanmar Airlines Public Co., Ltd",
    code: "Y5",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/Y5@2x.png"
  },
  {
    name: "Afriqiyah Airways",
    code: "8U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8U@2x.png"
  },
  {
    name: "Shenzhen Airlines",
    code: "ZH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZH@2x.png"
  },
  {
    name: "Avelo Airlines",
    code: "XP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XP@2x.png"
  },
  {
    name: "DHL Aviation EEMEA B.S.C.(c)",
    code: "ES",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ES@2x.png"
  },
  {
    name: "Kyrgyz Trans Avia",
    code: "6K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6K@2x.png"
  },
  {
    name: "Kan Air",
    code: "K8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K8@2x.png"
  },
  {
    name: "Centrum Air",
    code: "C6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C6@2x.png"
  },
  {
    name: "Beijing Capital Airlines",
    code: "JD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JD@2x.png"
  },
  {
    name: "Belair Airlines",
    code: "4T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4T@2x.png"
  },
  {
    name: "Alsa Grupo SLU",
    code: "5I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5I@2x.png"
  },
  {
    name: "Level",
    code: "LV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LV@2x.png"
  },
  {
    name: "Kam Air",
    code: "RQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RQ@2x.png"
  },
  {
    name: "Vietnam Airlines",
    code: "VN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VN@2x.png"
  },
  {
    name: "Iliamna Air Taxi Inc.",
    code: "V8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V8@2x.png"
  },
  {
    name: "Clairmont Holdings Ltd dba VI Air Link",
    code: "V6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V6@2x.png"
  },
  {
    name: "Caribbean Air Export Import Inc.",
    code: "CB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CB@2x.png"
  },
  {
    name: "Nile Air",
    code: "NP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NP@2x.png"
  },
  {
    name: "MyWay Airlines",
    code: "MJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/MJ@2x.png"
  },
  {
    name: "Air Uganda",
    code: "U7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U7@2x.png"
  },
  {
    name: "Air Inuit",
    code: "3H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3H@2x.png"
  },
  {
    name: "Bringer Air Cargo",
    code: "E6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/E6@2x.png"
  },
  {
    name: "Virgin Australia",
    code: "VA",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/VA@2x.png"
  },
  {
    name: "Shirak Avia",
    code: "5G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5G@2x.png"
  },
  {
    name: "Norwegian Air Shuttle",
    code: "DY",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DY@2x.png"
  },
  {
    name: "Jetstar Japan",
    code: "GK",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/GK@2x.png"
  },
  {
    name: "Nordic Regional Airline",
    code: "N7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N7@2x.png"
  },
  {
    name: "LAM Mozambique Airlines",
    code: "TM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TM@2x.png"
  },
  {
    name: "Qanot Sharq",
    code: "HH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HH@2x.png"
  },
  {
    name: "French Armed Forces",
    code: "RD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RD@2x.png"
  },
  {
    name: "Armenian Airlines",
    code: "JI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JI@2x.png"
  },
  {
    name: "Arkhangelsk-2",
    code: "ÐÐ§",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ÐÐ§@2x.png"
  },
  {
    name: "China Express Airlines",
    code: "G5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/G5@2x.png"
  },
  {
    name: "Warbelow's Air Ventures",
    code: "4W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4W@2x.png"
  },
  {
    name: "Royal Nepal Airlines",
    code: "RA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RA@2x.png"
  },
  {
    name: "Air North Charter and Training Ltd.",
    code: "4N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4N@2x.png"
  },
  {
    name: "AnadoluJet",
    code: "0T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0T@2x.png"
  },
  {
    name: "Berjaya Air",
    code: "J8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J8@2x.png"
  },
  {
    name: "StarFlyer",
    code: "7G",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/7G@2x.png"
  },
  {
    name: "Aero Nomad Airlines",
    code: "KA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KA@2x.png"
  },
  {
    name: "Swiss International Air Lines",
    code: "LX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LX@2x.png"
  },
  {
    name: "ACT Havayollari A.S.",
    code: "9T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9T@2x.png"
  },
  {
    name: "Sun-Air of Scandinavia",
    code: "EZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EZ@2x.png"
  },
  {
    name: "Edelweiss Air",
    code: "WK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WK@2x.png"
  },
  {
    name: "Georgian Airways",
    code: "A9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A9@2x.png"
  },
  {
    name: "Nomad Aviation (PTY) Ltd.",
    code: "N6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N6@2x.png"
  },
  {
    name: "Solaseed Air",
    code: "6J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6J@2x.png"
  },
  {
    name: "Cimber",
    code: "QA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QA@2x.png"
  },
  {
    name: "ZIPAIR Tokyo",
    code: "ZG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZG@2x.png"
  },
  {
    name: "Shanghai Airlines",
    code: "FM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FM@2x.png"
  },
  {
    name: "Air Berlin",
    code: "AB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AB@2x.png"
  },
  {
    name: "AirAsia X",
    code: "D7",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/D7@2x.png"
  },
  {
    name: "Department of National Defence",
    code: "YF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YF@2x.png"
  },
  {
    name: "JSC Aircompany ATMA",
    code: "IM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IM@2x.png"
  },
  {
    name: "Air New Zealand",
    code: "NZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NZ@2x.png"
  },
  {
    name: "China Airlines",
    code: "CI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CI@2x.png"
  },
  {
    name: "Skytrans Airlines",
    code: "Q6",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/Q6@2x.png"
  },
  {
    name: "Central Mountain Air",
    code: "9M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9M@2x.png"
  },
  {
    name: "One Jet, Inc.",
    code: "J1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J1@2x.png"
  },
  {
    name: "Air Armenia",
    code: "QN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QN@2x.png"
  },
  {
    name: "Level",
    code: "VK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VK@2x.png"
  },
  {
    name: "Skypower Express Airways",
    code: "NB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NB@2x.png"
  },
  {
    name: "Wizz Air",
    code: "W9",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/W9@2x.png"
  },
  {
    name: "LOT Polish Airlines",
    code: "LO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LO@2x.png"
  },
  {
    name: "Blue Islands",
    code: "SI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SI@2x.png"
  },
  {
    name: "Air Via Ltd.",
    code: "VL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VL@2x.png"
  },
  {
    name: "BB Airways",
    code: "BO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BO@2x.png"
  },
  {
    name: "Sansa Airlines",
    code: "RZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RZ@2x.png"
  },
  {
    name: "Pobeda",
    code: "DP",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DP@2x.png"
  },
  {
    name: "SUN-AIR",
    code: "ZU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZU@2x.png"
  },
  {
    name: "Passaredo Transportes Aereos S.A.",
    code: "2Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2Z@2x.png"
  },
  {
    name: "AccesRail",
    code: "9B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9B@2x.png"
  },
  {
    name: "United Airlines",
    code: "UA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UA@2x.png"
  },
  {
    name: "Utair",
    code: "UT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UT@2x.png"
  },
  {
    name: "Special Ground Handling Service -XH",
    code: "XH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XH@2x.png"
  },
  {
    name: "Thomas Cook Airlines",
    code: "MT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MT@2x.png"
  },
  {
    name: "Pacific Wings",
    code: "LW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LW@2x.png"
  },
  {
    name: "Swiftair",
    code: "WT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WT@2x.png"
  },
  {
    name: "Cyprus Airways",
    code: "CY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CY@2x.png"
  },
  {
    name: "Cargojet Airways Ltd.",
    code: "W8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W8@2x.png"
  },
  {
    name: "PAL Express",
    code: "2P",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/2P@2x.png"
  },
  {
    name: "Belle Air",
    code: "LZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LZ@2x.png"
  },
  {
    name: "BADR AIRLINES",
    code: "J4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J4@2x.png"
  },
  {
    name: "AirBridgeCargo",
    code: "RU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RU@2x.png"
  },
  {
    name: "Kosmos",
    code: "Ð“Ðš",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð“Ðš@2x.png"
  },
  {
    name: "Abacus International Pte. Ltd.",
    code: "1B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1B@2x.png"
  },
  {
    name: "Sunwing Airlines",
    code: "WG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/WG@2x.png"
  },
  {
    name: "RusLine",
    code: "7R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7R@2x.png"
  },
  {
    name: "Wings Air",
    code: "IW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/IW@2x.png"
  },
  {
    name: "Chu Kong Passenger Transport Co. Ltd.",
    code: "3A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3A@2x.png"
  },
  {
    name: "Primera Air",
    code: "PF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PF@2x.png"
  },
  {
    name: "Air Burkina",
    code: "2J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2J@2x.png"
  },
  {
    name: "Loganair",
    code: "LM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LM@2x.png"
  },
  {
    name: "Transavia Denmark",
    code: "PH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PH@2x.png"
  },
  {
    name: "Amapola Flyg AB",
    code: "HP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HP@2x.png"
  },
  {
    name: "Air Panama",
    code: "7P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7P@2x.png"
  },
  {
    name: "LGW Luftfahrtgesellschaft Walter",
    code: "HE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HE@2x.png"
  },
  {
    name: "Armenia Airways",
    code: "6A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6A@2x.png"
  },
  {
    name: "Topas Co. Ltd.",
    code: "K1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K1@2x.png"
  },
  {
    name: "South East Asian Airlines (SEAIR)International, Inc.",
    code: "XO",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XO@2x.png"
  },
  {
    name: "Aeronautical Telecommunications Ltd.(AEROTEL)",
    code: "XI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XI@2x.png"
  },
  {
    name: "Air Kiribati Limited",
    code: "IK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IK@2x.png"
  },
  {
    name: "Somon Air",
    code: "SZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SZ@2x.png"
  },
  {
    name: "OpenSkies",
    code: "EC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EC@2x.png"
  },
  {
    name: "Renegade Air",
    code: "0R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0R@2x.png"
  },
  {
    name: "Aerogaviota",
    code: "KG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KG@2x.png"
  },
  {
    name: "Scoot",
    code: "TZ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TZ@2x.png"
  },
  {
    name: "Grand China Air",
    code: "CN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CN@2x.png"
  },
  {
    name: "INFINI Travel Information, Inc.",
    code: "1F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1F@2x.png"
  },
  {
    name: "AirAsia Japan",
    code: "DJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DJ@2x.png"
  },
  {
    name: "Smokey Bay Air, Inc.",
    code: "2E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2E@2x.png"
  },
  {
    name: "Africa World Airlines",
    code: "AW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AW@2x.png"
  },
  {
    name: "SkyBahamas Airlines",
    code: "Q7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q7@2x.png"
  },
  {
    name: "China United Airlines",
    code: "KN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KN@2x.png"
  },
  {
    name: "East Horizon Airlines",
    code: "EA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EA@2x.png"
  },
  {
    name: "Aerolineas Argentinas",
    code: "AR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AR@2x.png"
  },
  {
    name: "Germania",
    code: "ST",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ST@2x.png"
  },
  {
    name: "fastjet",
    code: "FN",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FN@2x.png"
  },
  {
    name: "Thai Airways",
    code: "TG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TG@2x.png"
  },
  {
    name: "Red Wings Airlines",
    code: "WZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WZ@2x.png"
  },
  {
    name: "LATAM Ecuador",
    code: "XL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XL@2x.png"
  },
  {
    name: "PT. My Indo Airlines",
    code: "2Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2Y@2x.png"
  },
  {
    name: "Aruba Airlines",
    code: "AG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AG@2x.png"
  },
  {
    name: "JSC Transport Automated InformationSystems - TAIS",
    code: "1M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1M@2x.png"
  },
  {
    name: "Orenair",
    code: "R2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R2@2x.png"
  },
  {
    name: "CemAir",
    code: "5Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5Z@2x.png"
  },
  {
    name: "Bangkok Airways",
    code: "PG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PG@2x.png"
  },
  {
    name: "Solomon Airlines",
    code: "IE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IE@2x.png"
  },
  {
    name: "Air Astana",
    code: "KC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KC@2x.png"
  },
  {
    name: "Myanmar National Airlines",
    code: "UB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UB@2x.png"
  },
  {
    name: "TUI fly",
    code: "X3",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/X3@2x.png"
  },
  {
    name: "Nordwind Airlines",
    code: "N4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N4@2x.png"
  },
  {
    name: "Elite Airways",
    code: "7Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7Q@2x.png"
  },
  {
    name: "Air Alsie",
    code: "6I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6I@2x.png"
  },
  {
    name: "Starlink Aviation",
    code: "Q4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q4@2x.png"
  },
  {
    name: "Servicios AÃ©reos de los Andes",
    code: "FP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FP@2x.png"
  },
  {
    name: "Hi Fly Ltd",
    code: "5M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5M@2x.png"
  },
  {
    name: "Hex Air",
    code: "UD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UD@2x.png"
  },
  {
    name: "Olympic Air",
    code: "OA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OA@2x.png"
  },
  {
    name: "Corendon Airlines Europe",
    code: "XR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XR@2x.png"
  },
  {
    name: "Batik Air Indonesia",
    code: "ID",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ID@2x.png"
  },
  {
    name: "EuroAtlantic Airways S.A.",
    code: "YU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YU@2x.png"
  },
  {
    name: "Srilankan Airlines",
    code: "UL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UL@2x.png"
  },
  {
    name: "ExpressJet",
    code: "EV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EV@2x.png"
  },
  {
    name: "KLM",
    code: "KL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KL@2x.png"
  },
  {
    name: "Aviateca",
    code: "GU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GU@2x.png"
  },
  {
    name: "AIR CAIRO",
    code: "SM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SM@2x.png"
  },
  {
    name: "Flybondi",
    code: "FO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FO@2x.png"
  },
  {
    name: "Apsara International Air",
    code: "IP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IP@2x.png"
  },
  {
    name: "Joon",
    code: "JN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JN@2x.png"
  },
  {
    name: "Thomas Cook Airlines Belgium",
    code: "HQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HQ@2x.png"
  },
  {
    name: "Air Lituanica",
    code: "LT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LT@2x.png"
  },
  {
    name: "Anguilla Air Services, Ltd",
    code: "Q3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q3@2x.png"
  },
  {
    name: "Business jet",
    code: "0W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0W@2x.png"
  },
  {
    name: "Myanmar Airways International",
    code: "8M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8M@2x.png"
  },
  {
    name: "Biman Bangladesh Airlines",
    code: "BG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BG@2x.png"
  },
  {
    name: "Avianca",
    code: "AV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AV@2x.png"
  },
  {
    name: "Lufthansa CityLine",
    code: "CL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CL@2x.png"
  },
  {
    name: "S7 Airlines",
    code: "S7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S7@2x.png"
  },
  {
    name: "ITA Software Inc.",
    code: "1U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1U@2x.png"
  },
  {
    name: "C.A.I. Second",
    code: "VE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VE@2x.png"
  },
  {
    name: "Vista Georgia",
    code: "GT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GT@2x.png"
  },
  {
    name: "Ural Airlines",
    code: "U6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U6@2x.png"
  },
  {
    name: "Germanwings",
    code: "4U",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/4U@2x.png"
  },
  {
    name: "Sky Airlines",
    code: "ZY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZY@2x.png"
  },
  {
    name: "AVANZA",
    code: "6V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6V@2x.png"
  },
  {
    name: "Ultimate Jetcharters",
    code: "UE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UE@2x.png"
  },
  {
    name: "Air Busan",
    code: "BX",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/BX@2x.png"
  },
  {
    name: "Gambia International Airlines",
    code: "GC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GC@2x.png"
  },
  {
    name: "Laparkan Airways, Inc.",
    code: "LE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LE@2x.png"
  },
  {
    name: "Nouvelair",
    code: "BJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BJ@2x.png"
  },
  {
    name: "Uzbekistan Airways Express",
    code: "0H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0H@2x.png"
  },
  {
    name: "Liat",
    code: "LI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LI@2x.png"
  },
  {
    name: "Onur Air",
    code: "8Q",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/8Q@2x.png"
  },
  {
    name: "Wright Air Service",
    code: "8V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8V@2x.png"
  },
  {
    name: "Starbow",
    code: "S9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S9@2x.png"
  },
  {
    name: "Helvetic Airways",
    code: "2L",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/2L@2x.png"
  },
  {
    name: "TAR AerolÃ­neas",
    code: "YQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YQ@2x.png"
  },
  {
    name: "Japan Air Commuter",
    code: "JC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JC@2x.png"
  },
  {
    name: "Hi Fly",
    code: "5K",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/5K@2x.png"
  },
  {
    name: "NordStar",
    code: "Y7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Y7@2x.png"
  },
  {
    name: "Mavi Gok Airlines",
    code: "4M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4M@2x.png"
  },
  {
    name: "Silkair",
    code: "MI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MI@2x.png"
  },
  {
    name: "Southern Air Inc.",
    code: "9S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9S@2x.png"
  },
  {
    name: "Finnair",
    code: "AY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AY@2x.png"
  },
  {
    name: "Buzz",
    code: "RR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RR@2x.png"
  },
  {
    name: "Aeropelican Air Services",
    code: "OT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OT@2x.png"
  },
  {
    name: "Mesa Airlines",
    code: "YV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YV@2x.png"
  },
  {
    name: "Lodyssey",
    code: "0L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0L@2x.png"
  },
  {
    name: "TUI Airlines Netherlands",
    code: "OR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OR@2x.png"
  },
  {
    name: "Air Mediterranee",
    code: "ML",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ML@2x.png"
  },
  {
    name: "Mango",
    code: "JE",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/JE@2x.png"
  },
  {
    name: "Mokulele Airlines",
    code: "MW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MW@2x.png"
  },
  {
    name: "AirAsia Zest",
    code: "Z2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z2@2x.png"
  },
  {
    name: "First Air",
    code: "7F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7F@2x.png"
  },
  {
    name: "Caribbean Airlines",
    code: "BW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BW@2x.png"
  },
  {
    name: "Air Caucasus",
    code: "UY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UY@2x.png"
  },
  {
    name: "Kyrgyz Air",
    code: "KH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KH@2x.png"
  },
  {
    name: "Tiara Air Aruba",
    code: "3P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3P@2x.png"
  },
  {
    name: "Batik Air",
    code: "OD",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/OD@2x.png"
  },
  {
    name: "China Cargo Airlines",
    code: "CK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CK@2x.png"
  },
  {
    name: "Norse Atlantic Airways",
    code: "N0",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/N0@2x.png"
  },
  {
    name: "Jet Asia Airways",
    code: "JF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JF@2x.png"
  },
  {
    name: "Inter Air",
    code: "D6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D6@2x.png"
  },
  {
    name: "Air Europa",
    code: "UX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UX@2x.png"
  },
  {
    name: "E-Savtravel",
    code: "L1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L1@2x.png"
  },
  {
    name: "Monarch Airlines",
    code: "ZB",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/ZB@2x.png"
  },
  {
    name: "Dobrolet",
    code: "QD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QD@2x.png"
  },
  {
    name: "Antrak Air",
    code: "O4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O4@2x.png"
  },
  {
    name: "Air Seychelles",
    code: "HM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HM@2x.png"
  },
  {
    name: "iFly Airlines",
    code: "F7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F7@2x.png"
  },
  {
    name: "Air Arabia Egypt",
    code: "E5",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/E5@2x.png"
  },
  {
    name: "Neos",
    code: "NO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NO@2x.png"
  },
  {
    name: "Tarco Air",
    code: "3T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3T@2x.png"
  },
  {
    name: "Malaysia Airlines",
    code: "MH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MH@2x.png"
  },
  {
    name: "CitizenPlane",
    code: "1L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1L@2x.png"
  },
  {
    name: "Monacair",
    code: "QM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QM@2x.png"
  },
  {
    name: "Norwegian Air International",
    code: "D8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D8@2x.png"
  },
  {
    name: "Alrosa",
    code: "6R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6R@2x.png"
  },
  {
    name: "Lao Airlines",
    code: "QV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QV@2x.png"
  },
  {
    name: "HOP!",
    code: "AN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AN@2x.png"
  },
  {
    name: "Air Seoul",
    code: "RS",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/RS@2x.png"
  },
  {
    name: "Air Niugini",
    code: "PX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PX@2x.png"
  },
  {
    name: "Severstal Air",
    code: "D2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D2@2x.png"
  },
  {
    name: "Karinou Airlines",
    code: "U5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/U5@2x.png"
  },
  {
    name: "TAAG Angola Airlines",
    code: "DT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DT@2x.png"
  },
  {
    name: "El Al Israel Airlines",
    code: "LY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LY@2x.png"
  },
  {
    name: "Fiji Airways",
    code: "FJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FJ@2x.png"
  },
  {
    name: "Miami Air Lease, Inc.",
    code: "MG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MG@2x.png"
  },
  {
    name: "Austral Lineas Aereas",
    code: "AU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AU@2x.png"
  },
  {
    name: "Hahn Air Technologies",
    code: "X1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X1@2x.png"
  },
  {
    name: "Air Cargo Germany",
    code: "6U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6U@2x.png"
  },
  {
    name: "Kenmore Air",
    code: "M5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M5@2x.png"
  },
  {
    name: "Nas Air",
    code: "XY",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XY@2x.png"
  },
  {
    name: "NAYSA",
    code: "ZN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZN@2x.png"
  },
  {
    name: "Transavia",
    code: "HV",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/HV@2x.png"
  },
  {
    name: "Iberia",
    code: "IB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IB@2x.png"
  },
  {
    name: "Enter Air",
    code: "E4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/E4@2x.png"
  },
  {
    name: "Firefly",
    code: "FY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FY@2x.png"
  },
  {
    name: "Air One",
    code: "AP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AP@2x.png"
  },
  {
    name: "Azur Air",
    code: "ZF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZF@2x.png"
  },
  {
    name: "Air Italy",
    code: "I9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I9@2x.png"
  },
  {
    name: "ANA Wings",
    code: "EH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EH@2x.png"
  },
  {
    name: "FlexFlight",
    code: "W2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W2@2x.png"
  },
  {
    name: "Smartavia",
    code: "5N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5N@2x.png"
  },
  {
    name: "Rutas Aereas, C.A. dba  RUTACA",
    code: "5R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5R@2x.png"
  },
  {
    name: "Airshop B.V.",
    code: "FF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FF@2x.png"
  },
  {
    name: "Nextjet",
    code: "2N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2N@2x.png"
  },
  {
    name: "UVT Aero",
    code: "RT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RT@2x.png"
  },
  {
    name: "Bearskin Airlines",
    code: "JV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JV@2x.png"
  },
  {
    name: "SKOL",
    code: "Ð¡Ð”",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð¡Ð”@2x.png"
  },
  {
    name: "Orange Air, LLCN/A",
    code: "O3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O3@2x.png"
  },
  {
    name: "Freebird Airlines",
    code: "FH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FH@2x.png"
  },
  {
    name: "Aztec Airways",
    code: "AJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AJ@2x.png"
  },
  {
    name: "ATA Airlines",
    code: "I3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I3@2x.png"
  },
  {
    name: "Skippers Aviation",
    code: "HK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HK@2x.png"
  },
  {
    name: "AHK Air Hong Kong Limited",
    code: "LD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LD@2x.png"
  },
  {
    name: "Bamboo Airways",
    code: "QH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QH@2x.png"
  },
  {
    name: "Flybusteam",
    code: "Ð“Ð­",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð“Ð­@2x.png"
  },
  {
    name: "Amaszonas",
    code: "Z8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z8@2x.png"
  },
  {
    name: "Aurigny Air Services",
    code: "GR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GR@2x.png"
  },
  {
    name: "Cargo Three Inc. dba Pan Air Cargo",
    code: "3J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3J@2x.png"
  },
  {
    name: "Brindabella Airlines",
    code: "FQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FQ@2x.png"
  },
  {
    name: "Adria Airways",
    code: "JP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JP@2x.png"
  },
  {
    name: "Thai AirAsia",
    code: "FD",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FD@2x.png"
  },
  {
    name: "Wizz Air Malta",
    code: "W4",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/W4@2x.png"
  },
  {
    name: "MNG Airlines",
    code: "MB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MB@2x.png"
  },
  {
    name: "Donghai Airlines",
    code: "DZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DZ@2x.png"
  },
  {
    name: "9 Air",
    code: "AQ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/AQ@2x.png"
  },
  {
    name: "Spirit Airlines",
    code: "NK",
    is_lowcost: true,
    logo: "https://door2door-assets.s3.amazonaws.com/airline-logo/SP.png"
  },
  {
    name: "Southern Sky",
    code: "IH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IH@2x.png"
  },
  {
    name: "Lift",
    code: "GE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GE@2x.png"
  },
  {
    name: "FlyArna",
    code: "G6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/G6@2x.png"
  },
  {
    name: "European Air Transport",
    code: "QY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QY@2x.png"
  },
  {
    name: "Hawkair",
    code: "BH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BH@2x.png"
  },
  {
    name: "Azur Air Ukraine",
    code: "QU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QU@2x.png"
  },
  {
    name: "FlyOne",
    code: "5F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5F@2x.png"
  },
  {
    name: "Condor",
    code: "DF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DF@2x.png"
  },
  {
    name: "Cathay Pacific",
    code: "CX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CX@2x.png"
  },
  {
    name: "Canaryfly",
    code: "PM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PM@2x.png"
  },
  {
    name: "Ethiopian Airlines",
    code: "ET",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ET@2x.png"
  },
  {
    name: "Trenitalia",
    code: "7T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7T@2x.png"
  },
  {
    name: "XL Airways France",
    code: "SE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SE@2x.png"
  },
  {
    name: "Air Niamey",
    code: "A7",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/A7@2x.png"
  },
  {
    name: "Moldavian Airlines",
    code: "2M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2M@2x.png"
  },
  {
    name: "Equaflight Service",
    code: "E7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/E7@2x.png"
  },
  {
    name: "Flybe",
    code: "BE",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/BE@2x.png"
  },
  {
    name: "TransaeroÂ Airlines",
    code: "UN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UN@2x.png"
  },
  {
    name: "MAYAir",
    code: "7M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7M@2x.png"
  },
  {
    name: "Arik Air",
    code: "W3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/W3@2x.png"
  },
  {
    name: "Kenya Airways",
    code: "KQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KQ@2x.png"
  },
  {
    name: "Arajet",
    code: "DM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DM@2x.png"
  },
  {
    name: "Compass Airlines",
    code: "CP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CP@2x.png"
  },
  {
    name: "Sky Lease I, Inc.",
    code: "GG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GG@2x.png"
  },
  {
    name: "Skyview Airways Company Limiteddba Skyview",
    code: "RK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RK@2x.png"
  },
  {
    name: "DoKaSch",
    code: "3D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3D@2x.png"
  },
  {
    name: "Fly Lili",
    code: "FL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FL@2x.png"
  },
  {
    name: "Nakina Air Service",
    code: "T2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T2@2x.png"
  },
  {
    name: "Airkenya Express",
    code: "P2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P2@2x.png"
  },
  {
    name: "Navitaire",
    code: "1N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1N@2x.png"
  },
  {
    name: "Boutique Air",
    code: "4B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4B@2x.png"
  },
  {
    name: "Grand Canyon Airlines, Inc.dba Scenic Airlines",
    code: "YR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YR@2x.png"
  },
  {
    name: "Ghadames Air Transport",
    code: "NJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NJ@2x.png"
  },
  {
    name: "SkyUp Airlines",
    code: "PQ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/PQ@2x.png"
  },
  {
    name: "Yamal Airlines",
    code: "YC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YC@2x.png"
  },
  {
    name: "FlyArystan",
    code: "0Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0Y@2x.png"
  },
  {
    name: "TNT Airways",
    code: "3V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3V@2x.png"
  },
  {
    name: "AirConnect",
    code: "KS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KS@2x.png"
  },
  {
    name: "Air Alps Aviation",
    code: "A6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A6@2x.png"
  },
  {
    name: "RwandAir",
    code: "WB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WB@2x.png"
  },
  {
    name: "Corsair International",
    code: "SS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SS@2x.png"
  },
  {
    name: "IATA - Clearing HouseInternational Air Transport Association",
    code: "XB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XB@2x.png"
  },
  {
    name: "East African Safari Air",
    code: "B5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B5@2x.png"
  },
  {
    name: "Sabre Pacific",
    code: "1Z",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1Z@2x.png"
  },
  {
    name: "Philippine Airlines",
    code: "PR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PR@2x.png"
  },
  {
    name: "Twin Jet",
    code: "T7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T7@2x.png"
  },
  {
    name: "British Airways",
    code: "BA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BA@2x.png"
  },
  {
    name: "Tunisair Express",
    code: "UG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UG@2x.png"
  },
  {
    name: "Almasria Universal Airlines",
    code: "UJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UJ@2x.png"
  },
  {
    name: "Eritrean Airlines",
    code: "B8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B8@2x.png"
  },
  {
    name: "Air Algerie",
    code: "AH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AH@2x.png"
  },
  {
    name: "AerovÃ­as DAP",
    code: "V5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V5@2x.png"
  },
  {
    name: "Air Nostrum",
    code: "YW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YW@2x.png"
  },
  {
    name: "Tradewind Aviation",
    code: "TJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TJ@2x.png"
  },
  {
    name: "Sol Lineas Aereas",
    code: "8R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8R@2x.png"
  },
  {
    name: "Danish Air Transport",
    code: "DX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DX@2x.png"
  },
  {
    name: "Go!",
    code: "G8",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/G8@2x.png"
  },
  {
    name: "Air Arabia",
    code: "G9",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/G9@2x.png"
  },
  {
    name: "Hong Kong Airlines",
    code: "HX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HX@2x.png"
  },
  {
    name: "Airlines PNG",
    code: "CG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CG@2x.png"
  },
  {
    name: "Iran Air Tours",
    code: "B9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B9@2x.png"
  },
  {
    name: "Calima Aviacion S.L",
    code: "3C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3C@2x.png"
  },
  {
    name: "Tassili Airlines",
    code: "SF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SF@2x.png"
  },
  {
    name: "Siam Air",
    code: "O8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O8@2x.png"
  },
  {
    name: "ITA Airways",
    code: "AZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AZ@2x.png"
  },
  {
    name: "Zambezi Airlines",
    code: "ZJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZJ@2x.png"
  },
  {
    name: "Executive Express Aviation LLC dbaSouthern Airways",
    code: "9X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9X@2x.png"
  },
  {
    name: "Rotana Jet",
    code: "RG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RG@2x.png"
  },
  {
    name: "Air India Express",
    code: "IX",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/IX@2x.png"
  },
  {
    name: "Royal Air Maroc",
    code: "AT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AT@2x.png"
  },
  {
    name: "Airbus Transport International",
    code: "4Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4Y@2x.png"
  },
  {
    name: "Iberojet",
    code: "E9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/E9@2x.png"
  },
  {
    name: "WOW Air ehf",
    code: "WW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/WW@2x.png"
  },
  {
    name: "Travel Service Slovensko",
    code: "6D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6D@2x.png"
  },
  {
    name: "JSC Kazaviaspas",
    code: "ZS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZS@2x.png"
  },
  {
    name: "Windrose Airlines",
    code: "7W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7W@2x.png"
  },
  {
    name: "Horizon Air",
    code: "QX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QX@2x.png"
  },
  {
    name: "Kharkiv Airlines",
    code: "KW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KW@2x.png"
  },
  {
    name: "Air Tanzania",
    code: "TC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TC@2x.png"
  },
  {
    name: "Sunrise Airways",
    code: "S6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S6@2x.png"
  },
  {
    name: "CEIBA Intercontinental",
    code: "C2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C2@2x.png"
  },
  {
    name: "Fly Branson Travel dba Branson AirExpress",
    code: "1X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1X@2x.png"
  },
  {
    name: "Alaska Seaplane",
    code: "J5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J5@2x.png"
  },
  {
    name: "Thomas Cook Airlines Scandinavia",
    code: "DK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DK@2x.png"
  },
  {
    name: "Aero Mongolia",
    code: "M0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M0@2x.png"
  },
  {
    name: "Aerolink Uganda Limited",
    code: "A8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A8@2x.png"
  },
  {
    name: "Austrian Airlines",
    code: "OS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OS@2x.png"
  },
  {
    name: "Islena de Inversiones S.A. de C.V.dba Islena Airlines",
    code: "WC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WC@2x.png"
  },
  {
    name: "Saudia",
    code: "SV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SV@2x.png"
  },
  {
    name: "HiSky",
    code: "H4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/H4@2x.png"
  },
  {
    name: "Virgin Atlantic",
    code: "VS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VS@2x.png"
  },
  {
    name: "Garuda Indonesia",
    code: "GA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GA@2x.png"
  },
  {
    name: "Caicos Express Airways",
    code: "9Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9Q@2x.png"
  },
  {
    name: "Sky Express",
    code: "GQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GQ@2x.png"
  },
  {
    name: "Citilink Airlines",
    code: "QG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/QG@2x.png"
  },
  {
    name: "GetJet",
    code: "GW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GW@2x.png"
  },
  {
    name: "Asian Wings Airways Limited",
    code: "YJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YJ@2x.png"
  },
  {
    name: "Southwind",
    code: "2S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2S@2x.png"
  },
  {
    name: "Niki",
    code: "HG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/HG@2x.png"
  },
  {
    name: "Safi Airways",
    code: "4Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4Q@2x.png"
  },
  {
    name: "Sutra Inc.",
    code: "1K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1K@2x.png"
  },
  {
    name: "Wideroe",
    code: "WF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WF@2x.png"
  },
  {
    name: "Thai AirAsia X",
    code: "XJ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XJ@2x.png"
  },
  {
    name: "Ryan Air Service",
    code: "7S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7S@2x.png"
  },
  {
    name: "Uni Air",
    code: "B7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B7@2x.png"
  },
  {
    name: "Air KBZ",
    code: "K7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K7@2x.png"
  },
  {
    name: "Volotea",
    code: "V7",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/V7@2x.png"
  },
  {
    name: "Polar Air Cargo Worldwide, Inc.",
    code: "PO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PO@2x.png"
  },
  {
    name: "Bassaka Air Limited",
    code: "5B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5B@2x.png"
  },
  {
    name: "Northwest",
    code: "0E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0E@2x.png"
  },
  {
    name: "Sun Country Airlines",
    code: "SY",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/SY@2x.png"
  },
  {
    name: "Premier Airlines",
    code: "0M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0M@2x.png"
  },
  {
    name: "DOT LT",
    code: "R6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R6@2x.png"
  },
  {
    name: "Premier Airlines",
    code: "PRM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PRM@2x.png"
  },
  {
    name: "Air Japan",
    code: "NQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NQ@2x.png"
  },
  {
    name: "STP Airways",
    code: "8F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8F@2x.png"
  },
  {
    name: "Royal Flight",
    code: "RL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RL@2x.png"
  },
  {
    name: "Air Transport International L.L.C.",
    code: "8C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8C@2x.png"
  },
  {
    name: "Tailwind Airlines",
    code: "TI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TI@2x.png"
  },
  {
    name: "Ariana Afghan Airlines",
    code: "FG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FG@2x.png"
  },
  {
    name: "Malawian Airlines",
    code: "3W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3W@2x.png"
  },
  {
    name: "Avior Airlines",
    code: "3R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3R@2x.png"
  },
  {
    name: "Jazz",
    code: "QK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QK@2x.png"
  },
  {
    name: "Allegiant Air",
    code: "G4",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/G4@2x.png"
  },
  {
    name: "Zagros Air Co.",
    code: "Z4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z4@2x.png"
  },
  {
    name: "EgyptAir",
    code: "MS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MS@2x.png"
  },
  {
    name: "ASL Airlines France",
    code: "5O",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5O@2x.png"
  },
  {
    name: "Khabavia",
    code: "ÐÐ˜",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ÐÐ˜@2x.png"
  },
  {
    name: "Lynden Air Cargo, LLC",
    code: "L2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L2@2x.png"
  },
  {
    name: "SkyWest Airlines",
    code: "OO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OO@2x.png"
  },
  {
    name: "Air Jet",
    code: "7A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7A@2x.png"
  },
  {
    name: "Jetairfly",
    code: "TB",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TB@2x.png"
  },
  {
    name: "PM Air LLC",
    code: "Z3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z3@2x.png"
  },
  {
    name: "SmartWings",
    code: "QS",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/QS@2x.png"
  },
  {
    name: "Maya Island Air",
    code: "MY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MY@2x.png"
  },
  {
    name: "AerolÃ­neas Mas",
    code: "N3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N3@2x.png"
  },
  {
    name: "Cinnamon Air",
    code: "C7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/C7@2x.png"
  },
  {
    name: "Travelsky Technology Limited",
    code: "1E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1E@2x.png"
  },
  {
    name: "Vladivostok Air",
    code: "XF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XF@2x.png"
  },
  {
    name: "Daallo Airlines",
    code: "D3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/D3@2x.png"
  },
  {
    name: "Heli Air Monaco",
    code: "YO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YO@2x.png"
  },
  {
    name: "Envoy Air",
    code: "MQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MQ@2x.png"
  },
  {
    name: "Delta Air Lines",
    code: "DL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DL@2x.png"
  },
  {
    name: "Surinam Airways",
    code: "PY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PY@2x.png"
  },
  {
    name: "Iberia Express",
    code: "I2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I2@2x.png"
  },
  {
    name: "TUIfly Nordic",
    code: "6B",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6B@2x.png"
  },
  {
    name: "Etihad Airways",
    code: "EY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EY@2x.png"
  },
  {
    name: "LATAM Chile",
    code: "LA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LA@2x.png"
  },
  {
    name: "Uni-Top Airlines",
    code: "UW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UW@2x.png"
  },
  {
    name: "TurboJET",
    code: "8S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8S@2x.png"
  },
  {
    name: "Empire Airlines",
    code: "EM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EM@2x.png"
  },
  {
    name: "Vistara",
    code: "UK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UK@2x.png"
  },
  {
    name: "Tigerair Australia",
    code: "TT",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/TT@2x.png"
  },
  {
    name: "Vuelos Economicos Centroamericanos",
    code: "VU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VU@2x.png"
  },
  {
    name: "Interjet",
    code: "4O",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/4O@2x.png"
  },
  {
    name: "Cubana de AviaciÃ³n",
    code: "CU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CU@2x.png"
  },
  {
    name: "Aerocaribbean",
    code: "7L",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7L@2x.png"
  },
  {
    name: "MIAT Mongolian Airlines",
    code: "OM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OM@2x.png"
  },
  {
    name: "ASKY Airlines",
    code: "KP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KP@2x.png"
  },
  {
    name: "Pacific Coastal Airlines",
    code: "8P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8P@2x.png"
  },
  {
    name: "PT.Trigana Air Service",
    code: "IL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IL@2x.png"
  },
  {
    name: "ChallengAir",
    code: "1I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1I@2x.png"
  },
  {
    name: "Hong Kong Express Airways",
    code: "UO",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/UO@2x.png"
  },
  {
    name: "Sriwijaya Air",
    code: "SJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SJ@2x.png"
  },
  {
    name: "Dniproavia",
    code: "Z6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z6@2x.png"
  },
  {
    name: "Miami Air International",
    code: "LL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LL@2x.png"
  },
  {
    name: "Malta Air",
    code: "AL",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/AL@2x.png"
  },
  {
    name: "Southern Air",
    code: "9R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/9R@2x.png"
  },
  {
    name: "Qantas",
    code: "QF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/QF@2x.png"
  },
  {
    name: "Niger Airlines",
    code: "6N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6N@2x.png"
  },
  {
    name: "Afghan Jet International",
    code: "HN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HN@2x.png"
  },
  {
    name: "Atlantic Airways",
    code: "RC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RC@2x.png"
  },
  {
    name: "AirAsia India",
    code: "I5",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/I5@2x.png"
  },
  {
    name: "Bahrain Air",
    code: "BN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BN@2x.png"
  },
  {
    name: "Marsland Aviation",
    code: "M7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M7@2x.png"
  },
  {
    name: "Tyrolean Airways",
    code: "VO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VO@2x.png"
  },
  {
    name: "Norwegian Air",
    code: "DI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DI@2x.png"
  },
  {
    name: "Bahamasair",
    code: "UP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UP@2x.png"
  },
  {
    name: "Wizz Air",
    code: "5W",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5W@2x.png"
  },
  {
    name: "Stobart Air",
    code: "RE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RE@2x.png"
  },
  {
    name: "Bul Air",
    code: "LB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LB@2x.png"
  },
  {
    name: "ABX Air, Inc.",
    code: "GB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GB@2x.png"
  },
  {
    name: "LAN Express",
    code: "LU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LU@2x.png"
  },
  {
    name: "Korongo Airlines",
    code: "ZC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZC@2x.png"
  },
  {
    name: "Air Tahiti Nui",
    code: "TN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TN@2x.png"
  },
  {
    name: "Itek Air",
    code: "GI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GI@2x.png"
  },
  {
    name: "Thomson Airways",
    code: "BY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BY@2x.png"
  },
  {
    name: "Maluti Sky",
    code: "7D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7D@2x.png"
  },
  {
    name: "Viva Air",
    code: "VV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VV@2x.png"
  },
  {
    name: "Alpine Aviation Inc.",
    code: "5A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5A@2x.png"
  },
  {
    name: "FedEx",
    code: "FX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/FX@2x.png"
  },
  {
    name: "ALS Ltd.",
    code: "K4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K4@2x.png"
  },
  {
    name: "Tianjin Airlines",
    code: "GS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GS@2x.png"
  },
  {
    name: "Global Aviation Services Group",
    code: "5S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5S@2x.png"
  },
  {
    name: "Sylt Air GmbH",
    code: "7E",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7E@2x.png"
  },
  {
    name: "ULS Airlines Cargo",
    code: "GO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GO@2x.png"
  },
  {
    name: "Galileo International",
    code: "1V",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1V@2x.png"
  },
  {
    name: "Royal Brunei",
    code: "BI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BI@2x.png"
  },
  {
    name: "Telair International GmbH",
    code: "T8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T8@2x.png"
  },
  {
    name: "Arkia",
    code: "IZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IZ@2x.png"
  },
  {
    name: "Qazaq Air",
    code: "IQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/IQ@2x.png"
  },
  {
    name: "Air Wisconsin Airlines Corporation(AWAC)",
    code: "ZW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZW@2x.png"
  },
  {
    name: "Jatayu Airlines",
    code: "JZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JZ@2x.png"
  },
  {
    name: "PortugÃ¡lia",
    code: "NI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NI@2x.png"
  },
  {
    name: "Exec Air, Inc. of Naples",
    code: "X7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/X7@2x.png"
  },
  {
    name: "Himalaya Airlines",
    code: "H9",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/H9@2x.png"
  },
  {
    name: "Papillon Airways",
    code: "HI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HI@2x.png"
  },
  {
    name: "Continental Micronesia, Inc.",
    code: "CS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CS@2x.png"
  },
  {
    name: "Thai Vietjet Air",
    code: "V9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V9@2x.png"
  },
  {
    name: "Valuair",
    code: "VF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VF@2x.png"
  },
  {
    name: "Great Lakes Airlines",
    code: "ZK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZK@2x.png"
  },
  {
    name: "South Airlines",
    code: "YG",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YG@2x.png"
  },
  {
    name: "Titan Airways Limited",
    code: "ZT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZT@2x.png"
  },
  {
    name: "Tunisair",
    code: "TU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TU@2x.png"
  },
  {
    name: "Gulf Air",
    code: "GF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GF@2x.png"
  },
  {
    name: "Novoair",
    code: "VQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VQ@2x.png"
  },
  {
    name: "Cayman Airways",
    code: "KX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KX@2x.png"
  },
  {
    name: "Braathens Regional",
    code: "DC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DC@2x.png"
  },
  {
    name: "Jeju Air",
    code: "7C",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/7C@2x.png"
  },
  {
    name: "RUS Aviation",
    code: "R4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R4@2x.png"
  },
  {
    name: "MYAirline",
    code: "Z9",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Z9@2x.png"
  },
  {
    name: "Westair Aviation",
    code: "WV",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WV@2x.png"
  },
  {
    name: "Thai Lion Air",
    code: "SL",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/SL@2x.png"
  },
  {
    name: "Tandem Aero",
    code: "TQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TQ@2x.png"
  },
  {
    name: "Sun d'Or International Airlines",
    code: "2U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2U@2x.png"
  },
  {
    name: "Peach",
    code: "MM",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/MM@2x.png"
  },
  {
    name: "Kartika Airlines",
    code: "3Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3Y@2x.png"
  },
  {
    name: "TRIP Linhas AÃ©reas",
    code: "T4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/T4@2x.png"
  },
  {
    name: "Eurolot",
    code: "K2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K2@2x.png"
  },
  {
    name: "CJSC Royal Flight airlines",
    code: "4R",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4R@2x.png"
  },
  {
    name: "Hebei Airlines",
    code: "NS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NS@2x.png"
  },
  {
    name: "Tbilisi Airways",
    code: "TD",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TD@2x.png"
  },
  {
    name: "Skywings Asia Airlines Co., Ltd.",
    code: "ZA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ZA@2x.png"
  },
  {
    name: "Calm Air International",
    code: "MO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MO@2x.png"
  },
  {
    name: "Hainan Airlines",
    code: "HU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HU@2x.png"
  },
  {
    name: "American Airlines",
    code: "AA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AA@2x.png"
  },
  {
    name: "TezJet",
    code: "Ð”Ð–",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð”Ð–@2x.png"
  },
  {
    name: "Eastar Jet",
    code: "ZE",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/ZE@2x.png"
  },
  {
    name: "Panama Airways",
    code: "8A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8A@2x.png"
  },
  {
    name: "Corendon Airlines",
    code: "XC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XC@2x.png"
  },
  {
    name: "Colorful Guizhou Airlines",
    code: "GY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GY@2x.png"
  },
  {
    name: "Lucky Air",
    code: "8L",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/8L@2x.png"
  },
  {
    name: "Interstate Airlines",
    code: "I4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/I4@2x.png"
  },
  {
    name: "Insel Air",
    code: "8I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8I@2x.png"
  },
  {
    name: "Zapways, Inc.",
    code: "R1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R1@2x.png"
  },
  {
    name: "Regional Jet OÃœ",
    code: "EE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EE@2x.png"
  },
  {
    name: "Eurowings",
    code: "EW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/EW@2x.png"
  },
  {
    name: "Avianca Costa Rica",
    code: "LR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LR@2x.png"
  },
  {
    name: "Air Flamenco",
    code: "F4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/F4@2x.png"
  },
  {
    name: "Air Manas",
    code: "ZM",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/ZM@2x.png"
  },
  {
    name: "Conviasa",
    code: "V0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V0@2x.png"
  },
  {
    name: "Alitalia CityLiner",
    code: "CT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CT@2x.png"
  },
  {
    name: "ARINC(Aeronautical Radio, Inc.)",
    code: "XA",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XA@2x.png"
  },
  {
    name: "GoJet Airlines",
    code: "G7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/G7@2x.png"
  },
  {
    name: "Passaredo Linhas Aereas",
    code: "P3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/P3@2x.png"
  },
  {
    name: "Air Koryo",
    code: "JS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/JS@2x.png"
  },
  {
    name: "Emetebe S.A.",
    code: "0A",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0A@2x.png"
  },
  {
    name: "Air Zimbabwe",
    code: "UM",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UM@2x.png"
  },
  {
    name: "Singapore Airlines",
    code: "SQ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SQ@2x.png"
  },
  {
    name: "Orient Thai Airlines",
    code: "OX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OX@2x.png"
  },
  {
    name: "Radixx Solutions International, Inc.",
    code: "1D",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1D@2x.png"
  },
  {
    name: "Tigerair Philippines",
    code: "DG",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/DG@2x.png"
  },
  {
    name: "Jetlink Express",
    code: "J0",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J0@2x.png"
  },
  {
    name: "SATA Air Acores",
    code: "SP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SP@2x.png"
  },
  {
    name: "FlyOne",
    code: "3F",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3F@2x.png"
  },
  {
    name: "Axess International Network Inc.",
    code: "1J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1J@2x.png"
  },
  {
    name: "Carpatair",
    code: "V3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V3@2x.png"
  },
  {
    name: "BA Cityflyer",
    code: "CJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CJ@2x.png"
  },
  {
    name: "Royal Jordanian",
    code: "RJ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/RJ@2x.png"
  },
  {
    name: "Brussels Airlines",
    code: "SN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/SN@2x.png"
  },
  {
    name: "Shuttle America",
    code: "S5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/S5@2x.png"
  },
  {
    name: "Air Rarotonga",
    code: "GZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/GZ@2x.png"
  },
  {
    name: "Komiaviatrans",
    code: "KO",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KO@2x.png"
  },
  {
    name: "EcoJet",
    code: "8J",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8J@2x.png"
  },
  {
    name: "Vieques Air Link",
    code: "V4",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V4@2x.png"
  },
  {
    name: "Grumeti Air",
    code: "0G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0G@2x.png"
  },
  {
    name: "Sun Express",
    code: "XQ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/XQ@2x.png"
  },
  {
    name: "Air Timor",
    code: "6C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6C@2x.png"
  },
  {
    name: "MetroJet",
    code: "7K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7K@2x.png"
  },
  {
    name: "Cambodia Airways",
    code: "KR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KR@2x.png"
  },
  {
    name: "North Flying",
    code: "M3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/M3@2x.png"
  },
  {
    name: "Condor",
    code: "DE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/DE@2x.png"
  },
  {
    name: "Skyway Costa Rica",
    code: "LC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LC@2x.png"
  },
  {
    name: "Canadian North",
    code: "5T",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5T@2x.png"
  },
  {
    name: "Up Israel",
    code: "86",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/86@2x.png"
  },
  {
    name: "Bemidji Airlines",
    code: "CH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CH@2x.png"
  },
  {
    name: "Nolinor Aviation",
    code: "N5",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/N5@2x.png"
  },
  {
    name: "SKS Airways",
    code: "KI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KI@2x.png"
  },
  {
    name: "Compagnie Africaine d'Aviation",
    code: "BU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BU@2x.png"
  },
  {
    name: "Trans Air Congo",
    code: "Q8",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Q8@2x.png"
  },
  {
    name: "Thai Express Air Co. Ltd",
    code: "EX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EX@2x.png"
  },
  {
    name: "Kunming Airlines",
    code: "KY",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KY@2x.png"
  },
  {
    name: "Island Air",
    code: "WP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/WP@2x.png"
  },
  {
    name: "Nippon Cargo Airlines",
    code: "KZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KZ@2x.png"
  },
  {
    name: "HOP!",
    code: "YS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YS@2x.png"
  },
  {
    name: "Air France",
    code: "AF",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AF@2x.png"
  },
  {
    name: "Avianca Ecuador",
    code: "2K",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2K@2x.png"
  },
  {
    name: "Sunday Airlines",
    code: "0S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0S@2x.png"
  },
  {
    name: "Nesma Airlines",
    code: "NE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/NE@2x.png"
  },
  {
    name: "Balkan",
    code: "Ð‘Ð",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/Ð‘Ð@2x.png"
  },
  {
    name: "Middle East Airlines",
    code: "ME",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/ME@2x.png"
  },
  {
    name: "Linear Air",
    code: "O2",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/O2@2x.png"
  },
  {
    name: "BH Air",
    code: "8H",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/8H@2x.png"
  },
  {
    name: "Sabre Inc.",
    code: "1S",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1S@2x.png"
  },
  {
    name: "Ak Bars Aero",
    code: "2B",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/2B@2x.png"
  },
  {
    name: "Taquan Air",
    code: "K3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/K3@2x.png"
  },
  {
    name: "Mandarin Airlines",
    code: "AE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/AE@2x.png"
  },
  {
    name: "US-Bangla Airlines",
    code: "BS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/BS@2x.png"
  },
  {
    name: "Vanilla Air",
    code: "JW",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/JW@2x.png"
  },
  {
    name: "SNCF",
    code: "2C",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2C@2x.png"
  },
  {
    name: "Premier Trans Aire Inc.",
    code: "3X",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3X@2x.png"
  },
  {
    name: "TAP Portugal",
    code: "TP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TP@2x.png"
  },
  {
    name: "Air Transat",
    code: "TS",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TS@2x.png"
  },
  {
    name: "Perimeter Aviation Ltd.",
    code: "YP",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YP@2x.png"
  },
  {
    name: "Yeti Airlines Domestic Pvt. Ltd.",
    code: "YT",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YT@2x.png"
  },
  {
    name: "Avia Traffic Company",
    code: "YK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/YK@2x.png"
  },
  {
    name: "Volaris",
    code: "Y4",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/Y4@2x.png"
  },
  {
    name: "CM Airlines",
    code: "CC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/CC@2x.png"
  },
  {
    name: "Hunnu Air",
    code: "MR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MR@2x.png"
  },
  {
    name: "Tigerair Taiwan",
    code: "IT",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/IT@2x.png"
  },
  {
    name: "Precision Air",
    code: "PW",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PW@2x.png"
  },
  {
    name: "Air Urga",
    code: "3N",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3N@2x.png"
  },
  {
    name: "TACV Cabo Verde Airlines",
    code: "VR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/VR@2x.png"
  },
  {
    name: "Travelport Global Distribution SystemB.V.",
    code: "1G",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1G@2x.png"
  },
  {
    name: "Aero-Tropics Air Services",
    code: "HC",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/HC@2x.png"
  },
  {
    name: "African Express Airways (K)  Limited",
    code: "XU",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XU@2x.png"
  },
  {
    name: "Worldspan",
    code: "1P",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/1P@2x.png"
  },
  {
    name: "Lao Skyway",
    code: "LK",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LK@2x.png"
  },
  {
    name: "Laudamotion",
    code: "OE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OE@2x.png"
  },
  {
    name: "Sky-Taxi",
    code: "TE",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/TE@2x.png"
  },
  {
    name: "Hydro - Quebec",
    code: "0Q",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/0Q@2x.png"
  },
  {
    name: "TAB - Transportes AÃ©reos Bolivianos",
    code: "B1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/B1@2x.png"
  },
  {
    name: "Auric Air Services Limited",
    code: "UI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UI@2x.png"
  },
  {
    name: "Skymark Airlines",
    code: "BC",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/BC@2x.png"
  },
  {
    name: "IHY Izmir Havayollari A.S.",
    code: "4I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/4I@2x.png"
  },
  {
    name: "Yakutia Airlines",
    code: "R3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/R3@2x.png"
  },
  {
    name: "IBS Software Services Americas, Inc.",
    code: "V1",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/V1@2x.png"
  },
  {
    name: "Mexicana de AviaciÃ³n",
    code: "MX",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/MX@2x.png"
  },
  {
    name: "Uganda Airlines",
    code: "UR",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/UR@2x.png"
  },
  {
    name: "Lufthansa",
    code: "LH",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/LH@2x.png"
  },
  {
    name: "Flydubai",
    code: "FZ",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/FZ@2x.png"
  },
  {
    name: "Star Peru",
    code: "2I",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/2I@2x.png"
  },
  {
    name: "Bulgarian Air Charter",
    code: "H6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/H6@2x.png"
  },
  {
    name: "AeroItalia",
    code: "XZ",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/XZ@2x.png"
  },
  {
    name: "IBC Airways",
    code: "II",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/II@2x.png"
  },
  {
    name: "Mann Yadanarpon Airlines",
    code: "7Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/7Y@2x.png"
  },
  {
    name: "Sky Airline",
    code: "H2",
    is_lowcost: true,
    logo: "https://pics.avs.io/64/64/H2@2x.png"
  },
  {
    name: "Zacarias Moreno",
    code: "6M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6M@2x.png"
  },
  {
    name: "Druk Air",
    code: "KB",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/KB@2x.png"
  },
  {
    name: "Air Dolomiti",
    code: "EN",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/EN@2x.png"
  },
  {
    name: "Afrijet Business Service",
    code: "J7",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/J7@2x.png"
  },
  {
    name: "Transportes AÃ©reos Regionales",
    code: "5U",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/5U@2x.png"
  },
  {
    name: "Southern Air Charter",
    code: "PL",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/PL@2x.png"
  },
  {
    name: "Mauritania Airlines International",
    code: "L6",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/L6@2x.png"
  },
  {
    name: "Silver Airways",
    code: "3M",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/3M@2x.png"
  },
  {
    name: "SmartLynx Airlines",
    code: "6Y",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/6Y@2x.png"
  },
  {
    name: "Aegean Airlines",
    code: "A3",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/A3@2x.png"
  },
  {
    name: "Hinterland Aviation",
    code: "OI",
    is_lowcost: false,
    logo: "https://pics.avs.io/64/64/OI@2x.png"
  }
]

module.exports = airlines



// WEBPACK FOOTER //
// ./src/data/airlines.js